import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgShare = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.4 3a2.7 2.7 0 1 1 0 5.399A2.7 2.7 0 0 1 17.4 3M6.6 9.3a2.7 2.7 0 1 1 .001 5.399 2.7 2.7 0 0 1 0-5.4M17.4 15.6a2.7 2.7 0 1 1 0 5.399 2.7 2.7 0 0 1 0-5.399"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.93 13.358 6.148 3.583m-.01-9.882L8.93 10.64"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgShare);
export default ForwardRef;
